<template>
  <div class="page--full bg-white career">
    <el-row type="flex" class="row--full flex-wrap">
      <el-col :sm="9" class="career__images">
        <carousel
          class="carousel"
          :perPage="1"
          :paginationEnabled="false"
          :navigationEnabled="true"
          navigationPrevLabel=""
          navigationNextLabel=""
          @pageChange="updateCurrentSlide"
        >
          <slide class="slide" v-for="(item, index) in careerImages" :key="index">
            <ImageWithLoader
              :src="require(`@/${item.src}.jpg`)"
              :preloadSrc="require(`@/assets/images/careers/career_preload.png`)"
            />
          </slide>
        </carousel>
        <div class="photo__note hidden-xs-only">
          <p>{{ careerImages[currentSlide].text }}</p>
        </div>
      </el-col>
      <el-col :sm="15" class="career__content">
        <div class="content__wrapper">
          <job-description :jobData="careerContent" />
          <br />
          <button
            class="content__button btn btn--secondary btn--bounce is-flex middle"
            @click="redirectTo({ name: 'job-apply', params: { id: careerId } })"
          >
            <span>Apply</span>
            <img src="@/assets/images/icons/arrow.svg" />
          </button>
          <div class="spacer"></div>
        </div>
      </el-col>
    </el-row>
    <div class="close" @click="$router.push(`/#careers`)">
      <img src="@/assets/images/icons/close.svg" alt="" />
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel';

import JobDescription from '@/components/JobDescription.vue';
import careerData from '@/assets/json/career.json';
import ImageWithLoader from '@/components/ImageWithLoader.vue';

export default {
  components: {
    Carousel,
    Slide,
    JobDescription,
    ImageWithLoader,
  },
  created() {
    const id = this.$route.params.id;
    this.careerId = id;
    this.careerContent = careerData.data[id].content;
    this.careerImages = careerData.data[id].images;
  },
  data() {
    return {
      careerId: '',
      careerContent: {},
      careerImages: [],
      currentSlide: 0,
    };
  },
  methods: {
    updateCurrentSlide(carouselIndex) {
      this.currentSlide = carouselIndex;
    },
    redirectTo({ name, params }) {
      this.$router.push({ name, params });
    },
  },
};
</script>

<style lang="scss" scoped>
.career {
  &__images {
    max-height: 60%;
    @media (min-width: $sm) {
      position: relative;
      max-height: 100%;
      height: 100%;
    }
    .vue-load-image {
      height: 100%;
      /deep/ img {
        height: 100%;
      }
    }
  }
  &__content {
    @media (min-width: $sm) {
      overflow: hidden;
      height: 100%;
      overflow-y: scroll;
    }
  }
}

.close {
  position: absolute;
  top: 3.125rem;
  right: 3.125rem;
  width: 3rem;
  height: 3rem;
  cursor: pointer;
}

.content {
  &__wrapper {
    width: 80%;
    margin: auto;
    margin-top: 2.5rem;
    @media (min-width: $sm) {
      margin-top: 0;
    }
  }
  &__button {
    @media (min-width: $sm) {
      width: 40%;
    }
    margin-bottom: 2rem;
  }
}

.job-photo {
  @media (min-width: $sm) {
  }
}

.photo {
  &__note {
    position: absolute;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    @media (min-width: $sm) {
      padding: 2.25rem 2.5rem;
    }
    @media (min-width: $xl) {
      padding: 2.25rem 3.5rem;
    }
    background: $color-white;
    font-weight: 500;
    font-size: 1.125rem;
    p {
      margin: 0;
    }
  }
}

.carousel {
  height: 100%;
  /deep/ .VueCarousel-wrapper {
    height: 100%;
    .VueCarousel-inner {
      height: 100% !important;
    }
  }
  // .slide__wrapper {
  //   @media (min-width: $sm) {
  //     margin-bottom: 0;
  //     padding: 1rem;
  //     padding-right: 4%;
  //   }
  //   @media (min-width: $xl) {
  //     padding: 1.875rem;
  //     padding-right: 7%;
  //   }
  // }
  /deep/ .VueCarousel-navigation {
    z-index: 5;
    right: 5rem;
    @media (min-width: $sm) {
      right: 4rem;
    }
    @media (min-width: $xl) {
      right: 5rem;
    }
    top: initial;
    bottom: 0;
    padding: 2.25rem 0;
    height: 1.625rem; // line-height
  }
}

.slide {
  box-sizing: border-box;
  position: relative;
  top: -5rem;
  @media (min-width: $sm) {
    position: static;
    padding: 1.25rem;
  }
  @media (min-width: $xl) {
    padding: 2.25rem;
  }
  position: relative;
  height: 100%;
}

.spacer {
  width: 100%;
  height: 4rem;
}
</style>
